import React from 'react'
import { MenuDesktop } from '../MenuDesktop'
import { MenuMobile } from '../MenuMobile'
import { Container, LogoContainer } from './style'

export const Header = () => {
  return (
    <Container>
      <LogoContainer>
        <h1>Igor Garcia</h1>
      </LogoContainer>
      <MenuMobile/>
      <MenuDesktop/>
    </Container>
  )
}
